module.exports = __webpack_public_path__ + "img/04c-Shop_651.ab1befae.jpg";